import type { UserData } from './types'

export const useUserStore = defineStore('user', () => {
  const userData = ref<UserData | null>(null)

  const getId = () => {
    const accessToken = useCookie('accessToken').value
    const base64Url = accessToken!.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join(''),
    )
    const decoded = JSON.parse(jsonPayload)
    return decoded.sub
  }

  const getFullName = computed(() => {
    if (userData.value === null) return ''

    return userData.value.name
  })

  const getProfile = computed(() => {
    if (userData.value === null) return ''

    return userData.value.profile[0]
  })

  const getProfileName = computed(() => {
    if (userData.value === null) return ''

    return userData.value.profile[0].name
  })

  const getPhoto = computed(() => {
    if (userData.value === null || userData.value.photo === '') return ''

    return `${import.meta.env.VITE_AVATAR_BASE_URL}/${userData.value.photo}`
  })

  const isSuperAdmin = computed(() => {
    if (getProfile.value === '') return false

    return getProfile.value.id === SUPERADMIN_ID
  })

  const isAdmin = computed(() => {
    if (getProfile.value === '') return false

    return getProfile.value.id === ADMIN_ID
  })

  const isCoordinator = computed(() => {
    return userData.value?.isCoordinator
  })

  return {
    userData,
    getId,
    getFullName,
    getProfile,
    getProfileName,
    getPhoto,
    isSuperAdmin,
    isAdmin,
    isCoordinator,
  }
})
